import React from 'react';
import { Layout, Menu, Dropdown, Avatar, Space, Typography } from 'antd';
import { 
  UserOutlined, 
  LogoutOutlined, 
  ProfileOutlined, 
  SoundOutlined,
  MenuOutlined,
  MenuFoldOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import useResponsive from '../../hooks/useResponsive';

const { Header } = Layout;
const { Text } = Typography;

const AppHeader = ({ onMenuToggle, mobileMenuVisible }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { isMobile, isTablet } = useResponsive();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <ProfileOutlined />,
      label: '个人资料',
      onClick: () => navigate('/profile')
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
      danger: true
    }
  ];

  // 获取用户显示名称
  const getUserDisplayName = () => {
    if (user?.name) return user.name;
    if (user?.username) return user.username;
    return '用户';
  };

  // 获取用户角色显示
  const getUserRoleDisplay = () => {
    if (user?.role === 'super_admin') return '超级管理员';
    if (user?.role === 'school_admin') return '学校管理员';
    if (user?.role === 'teacher' || user?.userType === 'teacher') return '教师';
    return '用户';
  };

  // 移动端Header样式
  const mobileHeaderStyle = {
    background: '#fff',
    padding: '0 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 999,
    height: 56
  };

  // 桌面端Header样式
  const desktopHeaderStyle = {
    background: '#fff',
    padding: '0 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 999
  };

  return (
    <Header style={isMobile ? mobileHeaderStyle : desktopHeaderStyle}>
      {/* 左侧区域 */}
      <div 
        style={{ 
          display: 'flex', 
          alignItems: 'center',
          cursor: 'pointer'
        }}
      >
        {/* 移动端菜单按钮 */}
        {isMobile && (
          <div 
            onClick={onMenuToggle}
            style={{
              fontSize: 20,
              padding: '8px 12px 8px 0',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {mobileMenuVisible ? <MenuFoldOutlined /> : <MenuOutlined />}
          </div>
        )}
        
        {/* Logo区域 */}
        <div 
          style={{ display: 'flex', alignItems: 'center' }}
          onClick={() => navigate('/dashboard')}
        >
          <SoundOutlined 
            style={{ 
              fontSize: isMobile ? '22px' : '28px', 
              color: '#1890ff', 
              marginRight: isMobile ? '8px' : '12px' 
            }} 
          />
          <div>
            <Text 
              strong 
              style={{ 
                fontSize: isMobile ? '15px' : '18px', 
                color: '#1890ff' 
              }}
            >
              教室小喇叭
            </Text>
            {/* 桌面端显示副标题 */}
            {!isMobile && (
              <Text 
                type="secondary" 
                style={{ fontSize: '12px', marginLeft: '8px' }}
              >
                管理系统
              </Text>
            )}
          </div>
        </div>
      </div>

      {/* 右侧用户信息 */}
      <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
        <Space style={{ cursor: 'pointer' }}>
          <Avatar 
            icon={<UserOutlined />} 
            style={{ backgroundColor: '#1890ff' }}
            size={isMobile ? 'default' : 'default'}
          />
          {/* 桌面端和平板端显示用户名 */}
          {!isMobile && (
            <div style={{ textAlign: 'left', whiteSpace: 'nowrap' }}>
              <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                {getUserDisplayName()}
                {!isTablet && ` (${getUserRoleDisplay()})`}
              </Text>
            </div>
          )}
        </Space>
      </Dropdown>
    </Header>
  );
};

export default AppHeader;
